// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCameraVideo = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M58 32C58 39.9442 57.0924 45.3537 56.5 48.0383C56.2461 49.1887 55.2213 50 54.0432 50C53.3752 50 52.7346 49.7346 52.2623 49.2623L42 39V47C42 48.8434 40.8435 50 39 50H9C7.15649 50 6 48.8434 6 47V17C6 15.1565 7.15649 14 9 14H39C40.8435 14 42 15.1565 42 17V25L52.2623 14.7377C52.7346 14.2653 53.3752 14 54.0432 14C55.2213 14 56.2461 14.8112 56.5 15.9616C57.0924 18.6463 58 24.0558 58 32Z" />
      <path d="M58 32C58 39.9442 57.0924 45.3537 56.5 48.0383C56.2461 49.1887 55.2213 50 54.0432 50C53.3752 50 52.7346 49.7346 52.2623 49.2623L42 39V47C42 48.8434 40.8435 50 39 50H9C7.15649 50 6 48.8434 6 47V17C6 15.1565 7.15649 14 9 14H39C40.8435 14 42 15.1565 42 17V25L52.2623 14.7377C52.7346 14.2653 53.3752 14 54.0432 14C55.2213 14 56.2461 14.8112 56.5 15.9616C57.0924 18.6463 58 24.0558 58 32Z" />
    </svg>
  );
};
